import React, {Component} from "react";
import PropTypes from "prop-types";
import {DragDropContext} from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import ImmutablePropTypes from "react-immutable-proptypes";

import {Task} from "v2/api/Records";
import DraggableTask from "v2/components/dnd/DraggableTask";

class ReorderTasks extends Component {  // eslint-disable-line react/prefer-stateless-function
  static propTypes = {
    data: ImmutablePropTypes.listOf(Task).isRequired,
    onMove: PropTypes.func.isRequired,
  }

  render() {
    const {data, onMove} = this.props;
    return (
      <div className="col-xs-12">
        {data.map(item => (
          <DraggableTask
            data={item}
            key={`task-${item.id}`}
            onMove={onMove} />
        ))}
      </div>
    );
  }
}

export default DragDropContext(HTML5Backend)(ReorderTasks);



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/dnd/ReorderTasks.js
 **/